$('.block-product-card-slider').each(function() {

	const slider = $(this);

    // Force all gradients to blue, since active slides will be red
    slider.find('.content-wrapper').each(function() {
        $(this).removeClass('gradient--red');
        $(this).addClass('gradient--blue');
    });

	let opts = {
        allowTouchMove: false,
        keyboard: {
            enabled: true,
        },
		loop: true,
		speed: 500,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        slidesPerView: 1.25,
        spaceBetween: global_helpers.defaults.slide_spacing,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
            640: {
                slidesPerView: 2.25,
            },
            1280: {
                slidesPerView: 3,
            },
        },

	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});
